import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { TESTIMONIALS as MOCK_TESTIMONIALS } from "../mock";
import { fetchTestimonials } from "../lib/api";

const Testimonials = () => {
  const [items, setItems] = useState(MOCK_TESTIMONIALS);

  useEffect(() => {
    let mounted = true;
    fetchTestimonials().then((data) => {
      if (mounted && Array.isArray(data) && data.length) setItems(data);
    });
    return () => { mounted = false; };
  }, []);

  return (
    <section id="reviews" className="relative py-24 md:py-32 bg-emerald-950 overflow-hidden">
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: "radial-gradient(circle at 20% 30%, rgba(16,185,129,0.25), transparent 40%), radial-gradient(circle at 80% 70%, rgba(251,191,36,0.15), transparent 40%)"
      }} />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.2em] text-emerald-300 font-semibold mb-4">Loved by travellers</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-[1.05]">
            Trips that <span className="italic text-amber-200">actually get planned.</span>
          </h2>
          <p className="mt-5 text-white/70 text-lg max-w-2xl">
            Real groups, real trips, real relief from spreadsheet chaos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((t) => (
            <figure
              key={t.id}
              className="rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 p-6 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(t.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-300 text-amber-300" />
                ))}
              </div>
              <blockquote className="text-white/90 text-[15px] leading-relaxed mb-5">
                “{t.quote}”
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-4 border-t border-white/10">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover border border-white/20" />
                <div>
                  <div className="text-white font-medium text-sm">{t.name}</div>
                  <div className="text-white/60 text-xs">{t.location}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Marquee logos */}
        <div className="mt-16 pt-10 border-t border-white/10">
          <div className="text-center text-white/50 text-xs uppercase tracking-[0.2em] mb-6">Featured across travel communities</div>
          <div className="overflow-hidden">
            <div className="marquee flex gap-14 whitespace-nowrap">
              {["TravelWeekly","Nomad Digest","Trip Society","Wander HQ","Route Zine","Backpackr","TravelWeekly","Nomad Digest","Trip Society","Wander HQ","Route Zine","Backpackr"].map((n, i) => (
                <span key={i} className="font-display italic text-2xl md:text-3xl text-white/40">{n}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
